module.exports = __webpack_public_path__ + "png/hero-confetti-2.png";